import { IconButton } from '../../IconButton/index.js'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { FORMAT_TEXT_COMMAND } from 'lexical'

export const Italic = ({ isItalic, disabled, size }) => {
  const [editor] = useLexicalComposerContext()

  return (
    <IconButton
      toggled={isItalic}
      tooltip="Italic"
      size={size}
      icon="italic-text"
      keyHint="Cmd+I"
      keyHintVisualOnly
      onClick={() => {
        editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic')
      }}
      disabled={disabled}
    />
  )
}
